module.exports = __webpack_public_path__ + "Roboto-Bold-webfont.3dcc0e0f2287e2e955cd.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/assets/fonts/roboto/Roboto-Bold-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto/Roboto-Bold-webfont.ttf
// module chunks = 2